import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import LinkOutlined from '@material-ui/icons/LinkOutlined';
import * as React from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';
import { CHECKOUT_SUN_URL } from 'settings';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import { Space } from 'v2/components/Shared/Space';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { ProductOffer } from 'v2/interfaces/product';

import { PricesList } from './PricesList';
import { useStyles } from './styles';

type LinksModalProps = {
  isAffiliate: boolean;
  isOpen: boolean;
  closeModal: () => void;
  offer: ProductOffer;
};

function LinksModal({ isAffiliate, isOpen, closeModal, offer }: LinksModalProps) {
  const classes = useStyles();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  function mountOfferLink(offer: ProductOffer) {
    const url = new URL(`${CHECKOUT_SUN_URL}/${offer.key}`);
    if (isAffiliate && user) {
      url.searchParams.append('a', String(user.id));
    }
    return String(url);
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  return (
    <Dialog
      open={isOpen}
      fullWidth
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle onClose={closeModal}>
        <Typography>
          <strong>Links da oferta</strong>
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.offerName}>
          <strong id='links-modal-offer-name'>{offer.name}</strong>
        </Typography>
        <p className={classes.checkoutLinkLabel}>Página de pagamento (Checkout Sun)</p>
        <div className={classes.checkoutLinkContainer}>
          <LinkOutlined style={{ fontSize: 18 }} />
          <a id='links-modal-offer-link' href={mountOfferLink(offer)} target='_blank' rel='noreferrer'>
            {mountOfferLink(offer)}
          </a>
          <IconButton
            id='links-modal-copy-button'
            className={classes.checkoutLinkCopyButton}
            size='small'
            onClick={() => copyLinkToClipboard(mountOfferLink(offer))}
          >
            <FileCopyOutlined style={{ fontSize: 18 }} />
          </IconButton>
        </div>
        {offer.prices?.length > 0 && <Space axis='vertical' size={30} />}
        <PricesList isAffiliate={isAffiliate} offer={offer} />
      </DialogContent>
    </Dialog>
  );
}

export { LinksModal };
